import { NotificationComponent, type Notification } from "../Notification";

interface NotificationContainerProps {
  notifications: Notification[];
  onRemove: (id: string) => void;
}

export function NotificationContainer({
  notifications,
  onRemove,
}: NotificationContainerProps) {
  if (notifications.length === 0) return null;

  return (
    <div
      aria-live="assertive"
      className="fixed top-16 left-0 right-0 md:top-20 px-4 py-4 pointer-events-none z-[60]"
    >
      <div className="max-w-md w-full mx-auto flex flex-col items-center space-y-4">
        {notifications.map((notification) => (
          <NotificationComponent
            key={notification.id}
            notification={notification}
            onRemove={onRemove}
          />
        ))}
      </div>
    </div>
  );
}
